//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { buildHeadingMixin } from '~/mixins/headingMixin'
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [buildHeadingMixin('heading'), buildHeadingMixin('copy'), parseTextMixin],
  props: {
    titleGradient: {
      type: Boolean,
      default: false
    },

    subtitle: {
      type: String,
      default: ''
    },

    subtitleGradient: {
      type: Boolean,
      default: false
    },

    showCta: {
      type: Boolean,
      default: false
    },

    ctaCopy: {
      type: String,
      default: ''
    },

    ctaLink: {
      type: String,
      default: ''
    }
  },

  computed: {
    classes () {
      return {
        Heading: true,
        'Heading--title-gradient': this.titleGradient,
        'Heading--subtitle-gradient': this.subtitleGradient
      }
    }
  }
}
